<template>
    <div class="layout-footer">
        <span>© {{ new Date().getFullYear() }}
            <RouterLink :to="{ name: 'dashboard' }">
                Imprion Takeover</RouterLink>, All rights Reserved
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
